import { initializeProject } from './initializeProject'
import { auth } from '../../Auth'
import checkFormIntegrity from './checkFormIntegrity'

export async function prepareProject(project, first, logger) {
  // Avoid mutating the input project; create a copy if needed
  let updatedProject = { ...project }

  if (!updatedProject.startedAt) {
    //console.log('Setting startedAt for project', updatedProject.id)
    await initializeProject(updatedProject)
    logger.categoryId = updatedProject.id
    const userDisplayName = auth.currentUser?.displayName
    logger.event(
      userDisplayName ? `${userDisplayName} started an intake` : 'Intake started',
      JSON.stringify(updatedProject, null, 2),
      3
    )
    return {}
  }

  const data = {}

  //console.log('Project already has a start time, skipping initialization', updatedProject.status)

  if (['Requested', 'To Be Scheduled', 'Scheduled'].includes(updatedProject.status)) {
    data.status = 'In Progress'
    updatedProject = { ...updatedProject, status: data.status } // Create new project object
  }

  let userIsFieldUser = false
  if (['Review'].includes(updatedProject.status)) {
    const { organization = {} } = updatedProject.inspection?.inspector || {}
    if (
      auth.sunkaizenUser?.organization?.id === organization.id &&
      auth.sunkaizenUser?.organization?.id !== updatedProject.organization?.id
    ) {
      userIsFieldUser = true
    } else {
      switch (auth.sunkaizenUser?.type) {
        case 'field-user':
          userIsFieldUser = true
          break
        case 'quality-manager':
        case 'admin':
        case 'client':
        case 'super-admin':
          if (first) {
            logger.categoryId = updatedProject.id
            const userDisplayName = auth.sunkaizenUser?.name
            logger.event(
              userDisplayName ? `${userDisplayName} started reviewing an intake` : 'Intake Review started',
              null,
              5
            )
            data.reviewer = {
              name: auth.sunkaizenUser?.name,
              id: auth.sunkaizenUser?.id,
              email: auth.sunkaizenUser?.email,
              type: auth.sunkaizenUser?.type,
            }
            updatedProject = { ...updatedProject, reviewer: data.reviewer } // Create new project object
          }
          break
        default:
          console.warn('Unexpected user accessed this project in review', auth.sunkaizenUser)
      }
    }
  }

  // Compute fields immutably
  let fields = { [updatedProject.id]: { images: updatedProject.photos } }
  const sectionOrder = updatedProject.intake.order || []
  Object.entries(updatedProject.intake.sections).forEach(([sectionId, section]) => {
    // a section present in `sections` but missing from `order` was deleted;
    // keep its fields (so saves still round-trip their stored answers) but
    // flag them so required/progress/scoring logic skips them
    const orphaned = !sectionOrder.includes(sectionId)
    const sectionFields = section?.fields || {}
    const mergedFields = orphaned
      ? Object.keys(sectionFields).reduce((acc, fieldId) => {
          acc[fieldId] = { ...sectionFields[fieldId], orphaned: true }
          return acc
        }, {})
      : sectionFields
    fields = { ...fields, ...mergedFields }
  })

  // Pass a copy of updatedProject to avoid mutations in checkFormIntegrity
  const { project: checkedProject, data: updatedData } = await checkFormIntegrity(
    { ...updatedProject },
    { ...data }
  )

  return { project: checkedProject, fields, userIsFieldUser }
}